/* __next_internal_client_entry_do_not_use__ default auto */ import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  0%, 52%, 100% {\n    transform: translateX(-190%) skewX(-18deg);\n    opacity: 0;\n  }\n  8% {\n    opacity: 0.24;\n  }\n  18% {\n    transform: translateX(235%) skewX(-18deg);\n    opacity: 0.58;\n  }\n  24% {\n    opacity: 0;\n  }\n  28% {\n    transform: translateX(-160%) skewX(-18deg);\n    opacity: 0;\n  }\n  34% {\n    opacity: 0.18;\n  }\n  44% {\n    transform: translateX(210%) skewX(-18deg);\n    opacity: 0.4;\n  }\n  48% {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Typography, useMediaQuery } from "__barrel_optimize__?names=Box,Typography,useMediaQuery!=!@mui/material";
import Carousel from "./Carousel";
import Link from "next/link";
import LandingButton from "./Button";
import { useTheme } from "@mui/material/styles";
import { keyframes } from "@mui/system";
const ctaShimmer = keyframes(_templateObject());
export default function LandingHero(param) {
    let { heroSlides } = param;
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isDesktop && /*#__PURE__*/ _jsx(Carousel, {
            sx: {
                marginTop: "20px",
                paddingX: "20px",
                "@media (min-width: 1024px)": {
                    paddingX: 0,
                    marginTop: "72px"
                }
            },
            children: heroSlides.map((it)=>{
                const hasTextContent = it.title || it.description;
                return /*#__PURE__*/ _jsxs(Box, {
                    height: 590,
                    position: "relative",
                    borderRadius: "16px",
                    overflow: "hidden",
                    sx: it.withBorder ? {
                        border: "1px solid #DCE3FC",
                        boxSizing: "border-box"
                    } : undefined,
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: it.image,
                            alt: "",
                            height: "100%",
                            width: "100%",
                            style: {
                                objectFit: "cover"
                            }
                        }),
                        hasTextContent && /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                position: "absolute",
                                top: "50%",
                                left: 20,
                                zIndex: 1,
                                transform: "translate(0,-50%)",
                                width: "90%",
                                "@media (min-width: 1024px)": {
                                    left: 60,
                                    width: "100%",
                                    maxWidth: "500px"
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h1",
                                    sx: {
                                        fontSize: 52,
                                        fontWeight: 500,
                                        paddingBottom: 1.5,
                                        "@media (min-width: 1024px)": {
                                            fontSize: 62,
                                            paddingBottom: 4
                                        }
                                    },
                                    children: it.title
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body1",
                                    children: it.description
                                })
                            ]
                        }),
                        it.buttonName && /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                position: "absolute",
                                left: 20,
                                bottom: 32,
                                zIndex: 1,
                                "@media (min-width: 1024px)": {
                                    left: 60,
                                    bottom: 48
                                }
                            },
                            children: /*#__PURE__*/ _jsx(Box, {
                                sx: {
                                    position: "relative",
                                    display: "inline-block",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: -12,
                                        bottom: -12,
                                        left: 0,
                                        width: "48%",
                                        background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.22) 18%, rgba(255,255,255,0.72) 50%, rgba(255,255,255,0.22) 82%, rgba(255,255,255,0) 100%)",
                                        animation: "".concat(ctaShimmer, " 3.4s ease-in-out infinite"),
                                        pointerEvents: "none",
                                        zIndex: 2
                                    },
                                    "& > a": {
                                        position: "relative",
                                        zIndex: 1,
                                        display: "inline-block"
                                    }
                                },
                                children: /*#__PURE__*/ _jsx(Link, {
                                    style: {
                                        color: "inherit",
                                        textDecoration: "inherit"
                                    },
                                    href: it.buttonLink,
                                    children: /*#__PURE__*/ _jsx(LandingButton, {
                                        fontSize: "16px",
                                        name: it.buttonName,
                                        paddingTop: 0
                                    })
                                })
                            })
                        })
                    ]
                }, it.image);
            })
        })
    });
}
